import "react-app-polyfill/stable";
import "core-js";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { I18nProvider } from "@lingui/react";
import i18n from "./i18n";

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <I18nProvider i18n={i18n}>
      <App />
    </I18nProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
